const moduleList = {
  bindings: {
    selection: '<',
    onSelect: '&',
  },
  templateUrl: '/modules/configurationManagement/train-management/module-list/module-list.html',
  controller: 'ModuleListController',
};

angular
  .module('configuration-management.module')
  .component('moduleList', moduleList);